export default __webpack_public_path__ + "static/media/drishti_black.19f2e2ce.webp";